module.exports = __webpack_public_path__ + "static/media/card-bm.1fc4d001.png";